import Image1 from '../assets/images/result/01.png';
import Image2 from '../assets/images/result/02.png';
import Image3 from '../assets/images/result/07.png';
import Image4 from '../assets/images/result/08.png';
import Image5 from '../assets/images/result/15.png';
import Image6 from '../assets/images/result/16.png';

export const resultsShowcaseData = [
  {
    id: 1,
    name: 'Rishabh Jain',
    exam: 'JEE Main 2024',
    result: '99.92 %ile',
    selection: 'IIT Bombay',
    image: Image1
  },
  {
    id: 2,
    name: 'Yuvraj Tak',
    exam: 'JEE Main 2024',
    result: '99.67 %ile',
    selection: 'NIT Jaipur',
    image: Image2
  },
  {
    id: 3,
    name: 'Rahul Maru',
    exam: 'JEE Advanced 2024',
    result: 'AIR 938',
    selection: 'IIT Bombay',
    image: Image3
  },
  {
    id: 4,
    name: 'Tanay Laddha',
    exam: 'JEE Advanced 2024',
    result: 'AIR 1041',
    selection: 'IIT Hyderabad',
    image: Image4
  },
  {
    id: 5,
    name: 'Adhya Pareek',
    exam: 'Class 12 Board',
    result: '97 %',
    selection: 'District Topper',
    image: Image5
  },
  {
    id: 6,
    name: 'Rishabh Jain',
    exam: 'Class 12 Board',
    result: '92 %',
    selection: 'Science Stream',
    image: Image6
  }  
];
